import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
const contactSubmitUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaaboutus/contact-us`;
const enquirySubmitUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaaboutus/enquiry`;


// Actions
const contactDataRequested = () => ({
    type: types.CONTACT_REQUEST
  });

const contactDataSuccess = data => ({
  type: types.CONTACT_SUCCESS,
  data
});

const contactDataFailure = error => ({
  type: types.CONTACT_FAILURE,
  error
});

//Enquiry form 

const enquiryDataRequested = () => ({
  type: types.ENQUIRY_REQUEST
});

const enquiryDataSuccess = data => ({
type: types.ENQUIRY_SUCCESS,
data
});

const enquiryDataFailure = error => ({
type: types.ENQUIRY_FAILURE,
error
});


// API
export const saveContactData = (options) => {
  return dispatch => {
    dispatch(contactDataRequested());
    axios.post(contactSubmitUrl, {
        options } , {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
      
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(contactDataSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(contactDataFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(contactDataFailure(err.message));
      });
  };
};

//Enquiry form save function 

export const saveEnquiryData = (options) => {
  return dispatch => {
    dispatch(enquiryDataRequested());
    axios.post(enquirySubmitUrl, {
        options } , {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
      
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(enquiryDataSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(enquiryDataFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(contactDataFailure(err.message));
      });
  };
};
